import { render, staticRenderFns } from "./CustomDataGrid.vue?vue&type=template&id=45036765&"
import script from "./CustomDataGrid.vue?vue&type=script&lang=js&"
export * from "./CustomDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports